<div style="display: flex; flex-direction: row;">
  <div oncontextmenu="return false;" class="childWrapper">
    <div *ngFor="let item of reportsOptions">
      <div [ngClass]="{
          'active-menu': currentActiveTab?.header === item,
          'menuChild': currentActiveTab?.header !== item
        }">
        <div class="textlink" (click)="itemSelected(item)"
          (keydown.enter)="itemSelected(item)" (keydown.space)="itemSelected(item)">
          <div class="menuChildText item-open current-tab" [id]="item">
            {{ item }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>